import { render, staticRenderFns } from "./OnePagerStickyReceipt.vue?vue&type=template&id=428689de&scoped=true&"
import script from "./OnePagerStickyReceipt.vue?vue&type=script&lang=js&"
export * from "./OnePagerStickyReceipt.vue?vue&type=script&lang=js&"
import style0 from "./OnePagerStickyReceipt.vue?vue&type=style&index=0&id=428689de&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428689de",
  null
  
)

export default component.exports